import { computed, inject, Injectable } from '@angular/core';
import {
  BASE_GRID_VIEW_STATE,
  BaseGridViewState,
} from '@data-access/extendables';
import { SubmissionTypesAdminSignalState } from '../types';
import { WcgFilterIndicatorsOptions } from '@shared/interfaces/wcg-table-utils.interface';
import { updateGridFilter } from '@data-access/shared';

@Injectable({
  providedIn: 'root',
})
export class SubmissionTypesFacadeService extends BaseGridViewState {
  private readonly _submissionTypesGridStore =
    inject<SubmissionTypesAdminSignalState>(BASE_GRID_VIEW_STATE);

  readonly $workspaceSubTypes = computed(() =>
    this._submissionTypesGridStore.$workspaceSubTypes(),
  );

  constructor() {
    super();
  }

  updateSubmissionTypesAdminGridFilter(filter: WcgFilterIndicatorsOptions) {
    const _constructFilter = updateGridFilter(
      filter,
      this._submissionTypesGridStore.$advancedFilters(),
    );
    this.updateGrid(
      'filter',
      {
        filters: _constructFilter.filters,
        page: this._submissionTypesGridStore.$pageView().page,
        pageSize: this._submissionTypesGridStore.$pageView().pageSize,
      },
      true,
      false,
    );
  }
}
